// extracted by mini-css-extract-plugin
module.exports = {"container":"talent-tree_container_3mmdo","indicator":"talent-tree_indicator_1f6P9"};